export default {
  CollapsibleFareOption__STARTING_AT_LABEL: "starting at",
};
